import { motion } from 'motion/react';
import { tv } from 'tailwind-variants';

interface LoginTemplateProps {
  children: [React.ReactNode, React.ReactNode];
  isSignIn?: boolean;
}

const loginTemplate = tv({
  base: 'flex flex-row items-center justify-center min-h-screen bg-gray-05',
  variants: {
    signIn: {
      true: 'flex-row-reverse',
    },
  },
});

export function LoginTemplate({ children, isSignIn }: LoginTemplateProps) {
  return (
    <div className={`${loginTemplate({ signIn: isSignIn })} cx-login-template`}>
      <motion.div
        className="cx-login-form-panel flex min-h-screen flex-col items-center justify-center sm:flex-1 md:flex-4 lg:flex-[1.25] xl:flex-1"
        layout
      >
        {children[0]}
      </motion.div>

      <div className="cx-login-hero bg-gray-03 bg-login-background z-50 flex min-h-screen flex-1 flex-col items-center justify-center bg-cover bg-blend-overlay max-md:hidden">
        {children[1]}
      </div>
    </div>
  );
}
